<template>
  <div class="myswipper">
    <div class="switch-text" v-if="options">
      <span v-if="showstatus">{{ options.show }}</span>
      <span v-else>{{ options.hide }}</span>
    </div>
    <input
      type="checkbox"
      :checked="checked"
      :disabled="disabled"
      @change="changeSwitch"
    />
  </div>
</template>
<script>
export default {
  components: {
  },
  computed: {
  },
  model: {
    prop: 'checked',
    event: 'change'
  },
  data () {
    return {

    }
  },
  watch: {
  },
  methods: {
    changeSwitch (e) {
      // console.log('触发cahnge', e.target.checked)
      this.$emit('change', e.target.checked)
    }
  },
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object
    }
  },
  destroyed () {
  },
}
</script>
<style lang='scss' scoped>
// .myswipper{
//   display: flex;
//   align-items: center;
//   cursor: pointer;
//   width:52px;
//   input[type=checkbox] {
//     width: 52px;
//     height: 27px;
//     -webkit-appearance: none;
//     background-color: transparent;
//     border: 0;
//     outline: 0 !important;
//     color: #d8d8d8;
//     position: relative;
//     transition: all .3s ease;
//   }
//   input[type=checkbox]:before{
//     content: "";
//     display:block;
//     width: 52px;
//     height: 27px;
//     border: 1px solid #efe4e4;
//     // background-color: #EB9FA9;
//     box-sizing:border-box;
//     border-radius: 20px;
//     font-size: 16px;
//     position: absolute;
//   }
//   input[type=checkbox]:after{
//     content: "";
//     display:block;
//     width:21px;
//     border-radius:20px;
//     height: 21px;

//     line-height: 21px;
//     text-align: center;

//     left:3px;
//     top:3px;
//     // border: 1px solid #8f8f8f;
//     // background-color: #fff;
//     background-color: #e1e0e0;
//     box-sizing:border-box;
//     // box-shadow: 0 1px 3px rgba(0,0,0,.4);
//     border-radius: 20px;
//     position: absolute;
//     transition: all .3s ease;
//   }
//   input[type=checkbox]:disabled:before{
//     content: "";
//     display:block;
//     width: 1.04rem;
//     height: .64rem;
//     // border: 1px solid #999;
//     background-color: #999;
//     box-sizing:border-box;
//     border-radius: 20px;
//     position: absolute;
//   }
//   input[type=checkbox]:disabled:after{
//     content: "";
//     display:block;
//     width: .6rem;
//     height: .6rem;
//     left:1px;
//     top:1px;
//     border: 1px solid #fff;
//     background-color: #fff;
//     box-sizing:border-box;
//     // box-shadow: 0 1px 3px rgba(0,0,0,.4);
//     border-radius: 20px;
//     position: absolute;
//   }
//   input[type=checkbox]:checked:before{
//     content: "";
//     display:block;
//     width: 52px;
//     height: 27px;
//     // border: 1px solid #FFD2C2;
//     // background-color: #fff;
//     background: #EB9FA9;
//     box-sizing:border-box;
//     border-radius: 20px;
//     position: absolute;
//   }
//   input[type=checkbox]:checked:after{
//     content: "";
//     display:block;
//     width: 21px;
//     border-radius: 20px;
//     height: 21px;
//     -webkit-transform: translateX(86%);
//     transform: translateX(86%);
//     border:none;
//     background-color: #fff;
//     box-sizing:border-box;
//     left:9px;
//     // box-shadow: 0 1px 3px rgba(0,0,0,.4);

//     position: absolute;
//   }
//   .switch-text{
//     margin-right: 5px;
//   }
// }
</style>